export default function Input({
  label = "",
  inputSample = "",
  type = "",
  id = "",
  name = "",
  isReadOnly = true,
  isAuotComplete = false,
  isNumeric = false,
  isLTR = false,
  max,
  onChange,
  value,
}) {
  return (
    <div className="w-full flex flex-col gap-1">
      <label
        htmlFor={id}
        className="text-sm text-zi-text-light/50 dark:text-zi-text-dark/50"
      >
        {label}
      </label>
      <input
        defaultValue={inputSample}
        value={value}
        type={type}
        id={id}
        name={name}
        readOnly={isReadOnly}
        autoComplete={isAuotComplete}
        max={max}
        onInput={onChange}
        inputmode={isNumeric ? "numeric" : undefined}
        pattern={isNumeric ? "[0-9]*" : undefined}
        className={
          "w-full text-right bg-transparent outline-none rounded-md p-1 text-base " +
          "text-zi-text-light dark:text-zi-text-dark border border-zi-border-light dark:border-zi-border-dark " +
          (isReadOnly
            ? "border-opacity-0 dark:border-opacity-0 "
            : "border-opacity-100 dark:border-opacity-100 ") +
          (isReadOnly
            ? " "
            : "hocus:ring-1 hocus:ring-zi-border-light hocus:dark:ring-zi-border-dark ") +
          (isReadOnly
            ? " "
            : "hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark ") +
          (isLTR ? "[direction:ltr]" : "")
        }
      />
    </div>
  );
}
